const FIRST_NAME_REGEX = /^(?=.{1,50}$)[a-zA-Z]+(?:[-'\s][a-zA-Z]+)*$/;
const LAST_NAME_REGEX = /^(?=.{1,50}$)[a-zA-Z]+(?:[-'\s][a-zA-Z]+)*$/;
const EMAIL_REGEX = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
const DATE_REGEX = /^\d{2}-\d{2}-\d{4}$/;
const DIGIT_ONLY_REGEX = /\D/g;
const NUMERIC_INPUT_REGEX = /^-?\d*$/;
const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // MM/DD/YYYY
const REGEX_WITH_ACCENTEDCHARS = /^(?:[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ' .-]*|)$/;
const COMPLETE_INPUT = /_/ // check if string has underscore -- complete if input is completely filled is masked ex - 21/__/____ 

export {
    DATE_REGEX,
    DIGIT_ONLY_REGEX,
    EMAIL_REGEX,
    FIRST_NAME_REGEX,
    LAST_NAME_REGEX,
    NUMERIC_INPUT_REGEX,
    REGEX_WITH_ACCENTEDCHARS,
    DATE_MASK,
    COMPLETE_INPUT
};
